import { createSelector } from 'reselect'

const getPax = (state) => state.passengers.pax
const getTravelCards = (state) => state.passengers.travelCards
const areTravelCardsKnown = (state) => state.passengers.areTravelCardsKnown

const getAreThereTravelCards = createSelector(
  [getTravelCards],
  (travelCards) => travelCards && travelCards.length > 0
)

const getTravelCardCount = createSelector(
  [getTravelCards],
  (travelCards) => travelCards.length
)

const getPaxCount = createSelector(
  [getPax],
  (pax) => pax.length
)

export {
  getPax,
  getAreThereTravelCards,
  getTravelCards,
  getTravelCardCount,
  areTravelCardsKnown,
  getPaxCount,
}
